export class ApiError {
	constructor(axiosError) {
		this.error = axiosError;
		this.errorMessage = this.getErrorMessage();
	}

	getErrorMessage() {
		if (this.error?.response?.data?.message) {
			return this.error.response.data.message;
		}

		if (this.error?.message) {
			return this.error.message;
		}

		// Fallback
		return 'Undefined error.';
	}
}
